




















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import Loading from '@/components/icons/Loading.vue';

@Component({
  components: {
    Loading
  }
})
export default class Button extends Vue {
  @Prop(String) className?: string;
  @Prop(String) overrideStyle?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: 'Loading...' }) loadingLabel?: string;
  @Prop({ default: 'primary' }) colorSchema!: string;
  @Prop({ default: 'submit' }) type!: string;
  @Prop({ default: false }) responsive?: boolean;
  @Prop({ default: '' }) size?: string;

  @Emit('click')
  click() {
    if (this.onClick) this.onClick();
  }

  onClick() {}
}
